import HistoryRewardsRedeemed from 'components/Content/BeautyInsider/BeautyInsiderHistory/HistoryRewardsRedeemed/HistoryRewardsRedeemed';

export default HistoryRewardsRedeemed;
